import React, { useState } from 'react';
import './LearnMore.css';

const LearnMore = () => {
  const [option, setOption] = useState('newsletter');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleOptionChange = (e) => {
    setOption(e.target.value);
    setFormData({ name: '', email: '', phone: '', message: '' });
    setErrors({});
    setIsSubmitted(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prevState => ({
        ...prevState,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (option === 'contact' && !formData.message.trim()) {
      newErrors.message = 'Message is required';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length === 0) {
      try {
        let response;
        if (option === 'newsletter') {
          response = await fetch('/api/newsletter_signup', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: formData.name, email: formData.email })
          });
        } else {
          response = await fetch('/api/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          });
        }
        if (response.ok) {
          setIsSubmitted(true);
          setFormData({ name: '', email: '', phone: '', message: '' });
        } else {
          throw new Error('Failed to submit form');
        }
      } catch (error) {
        setErrors({ submit: 'Failed to submit form. Please try again.' });
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="learn-more-container">
      <h1>Learn More</h1>
      <p className="intro-text">
        Interested in learning more about our work? We'd love to hear from you. 
        Fill out the form below and we'll get back to you soon.
      </p>
      <div className="form-options">
        <label>
          <input
            type="radio"
            value="newsletter"
            checked={option === 'newsletter'}
            onChange={handleOptionChange}
          />
          Subscribe to our newsletter to learn more
        </label>
        <label style={{ marginLeft: 20 }}>
          <input
            type="radio"
            value="contact"
            checked={option === 'contact'}
            onChange={handleOptionChange}
          />
          Contact us with a message
        </label>
      </div>
      {isSubmitted ? (
        <div className="success-message">
          <h2>Thank You!</h2>
          <p>We've received your {option === 'newsletter' ? 'subscription' : 'message'} and will get back to you soon.</p>
        </div>
      ) : (
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'error' : ''}
            />
            {errors.name && <span className="error-message">{errors.name}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>
          {option === 'contact' && (
            <>
              <div className="form-group">
                <label htmlFor="phone">Phone (Optional)</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className={errors.message ? 'error' : ''}
                />
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>
            </>
          )}
          {errors.submit && <div className="error-message">{errors.submit}</div>}
          <button type="submit" className="submit-button">
            {option === 'newsletter' ? 'Subscribe' : 'Send Message'}
          </button>
        </form>
      )}
    </div>
  );
};

export default LearnMore; 